import { cn } from '@goaltree/ui/lib/utils'
import { Mic } from 'lucide-react'
import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'

type MicButtonProps = Omit<ComponentProps<'button'>, 'children'> & { listening: boolean }

// Inline dictation toggle for text inputs. The big record CTAs (Brain dump,
// bottom-nav) are intentionally different and don't use this.
export function MicButton({ listening, className, ...props }: MicButtonProps) {
  const { t } = useTranslation()
  const label = t(listening ? 'coach.stopDictation' : 'coach.dictate')
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={listening}
      title={label}
      className={cn(
        'flex size-[30px] shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-40',
        listening
          ? 'bg-destructive text-white hover:bg-destructive/90'
          : 'bg-primary/12 text-primary-text hover:bg-primary/20',
        className,
      )}
      {...props}
    >
      {listening ? (
        <span className="relative flex size-4 items-center justify-center">
          <span className="absolute inline-flex size-full animate-ping rounded-full bg-white/40" />
          <Mic className="relative size-4" strokeWidth={2.25} />
        </span>
      ) : (
        <Mic className="size-4" strokeWidth={2.25} />
      )}
    </button>
  )
}
